import styled from "@emotion/styled";
import { WRAPPED_SOL_MINT } from "@stepfinance/common";
import { StepTextInput } from "@stepfinance/react";
import type { NormalizedTokenAccount } from "@stepfinance/tokens";
import type { FC } from "react";

import { useLanguageContext } from "../../contexts/language/language";
import { AmountInput } from "../AmountInput/AmountInput";
import { InfoCard } from "../InfoCard/InfoCard";
import { TradeButton } from "../Trade";
import { useSendToken } from "./hooks";
import { ToAddressDiv } from "./shared";

interface SendTokenContentProps {
  fromAccount: NormalizedTokenAccount | null;
  closeModal: () => void;
}

export const SendTokenContent: FC<SendTokenContentProps> = ({ fromAccount, closeModal }) => {
  const {
    sendAmount,
    setSendAmount,
    sendMint,
    toAddressText,
    onAddressChange,
    disableSend,
    handleSend,
    sendButtonText,
    sendMintDecimals,
  } = useSendToken(fromAccount, closeModal);

  const {
    currentLanguageData: {
      pages: {
        dashboard: {
          modules: {
            balances: { sendTokenContent },
          },
        },
      },
    },
  } = useLanguageContext();

  return (
    <>
      <AmountInput
        amount={sendAmount}
        mint={sendMint}
        mintDecimals={sendMintDecimals}
        onAmountChange={(_event, amount) => {
          setSendAmount(amount);
        }}
      />
      <ToAddressDiv>{sendTokenContent.toAddress}</ToAddressDiv>
      <AdressInputContainer>
        <StepTextInput
          value={toAddressText}
          borderless
          inputSize="small"
          spellCheck={false}
          style={{ backgroundColor: "black" }}
          placeholder={sendTokenContent.addressInputPlaceholder}
          onChange={onAddressChange}
        />
      </AdressInputContainer>
      {sendMint.equals(WRAPPED_SOL_MINT) && (
        <>
          <InfoCard title={sendTokenContent.wrappedAssetInfoCard.title} type="info">
            {sendTokenContent.wrappedAssetInfoCard.infoContent}
          </InfoCard>
          <Spacer />
        </>
      )}
      <TradeButton disabled={disableSend} onClick={handleSend}>
        {sendButtonText}
      </TradeButton>
    </>
  );
};

const Spacer = styled.div`
  height: 20px;
`;

const AdressInputContainer = styled.div`
  margin-bottom: 30px;
`;
